import settings from '@/settings'

const post = (headers, data) => {
  // Cadastrar e edita assinatura
  return fetch(`${settings.apetrusApi}/assinatura/`, {
    method: 'post',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const get = (headers, filtros) => {
  // Pegar planos do posto ou rede
  let url = `${settings.apetrusApi}/assinatura/planos/`
  if (filtros) {
    Object.keys(filtros).forEach((filter) => {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${filter}=${filtros[filter]}`
    })
  }
  return fetch(url, {
    method: 'GET',
    cache: 'default',
    mode: 'cors',
    headers: headers
  })
}

const deletar = (headers, data) => {
  return fetch(`${settings.apetrusApi}/assinatura/`, {
    method: 'DELETE',
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const cadastrarIntervalos = (headers, data, cnpj, method) => { // Cadastrar e editar intervalos
  return fetch(`${settings.apetrusApi}/assinatura/intervalos/?empresa=${cnpj}`, {
    method: method,
    body: JSON.stringify(data),
    mode: 'cors',
    headers: headers
  })
}

const pegarIntervalos = (headers, data, cnpj) => {
  return fetch(`${settings.apetrusApi}/assinatura/intervalos/?page=${data.page}&empresa=${cnpj}`, {
    method: 'GET',
    cache: 'default',
    mode: 'cors',
    headers: headers
  })
}

const deletarIntervalos = (headers, data, cnpj) => {
  return fetch(`${settings.apetrusApi}/assinatura/intervalos/?id=${data.id}&empresa=${cnpj}`, {
    method: 'DELETE',
    cache: 'default',
    mode: 'cors',
    headers: headers
  })
}

export default {
  get,
  post,
  deletar,
  cadastrarIntervalos,
  pegarIntervalos,
  deletarIntervalos
}
